/* eslint-disable import/no-anonymous-default-export */
export default {
    dark: {
        primary: '#005EB8',
        secondary: '#ff8355',
        black: '#000'
    },
    light: {
        gray400: '#d7dbec',
        gray200: '#e6e9f4',
        gray100: '#f5f6fa',
        gray90: '#A1A7C4'
    },
    cost: {
        danger: '#f0142f',
        success: '#57b8ff',
        light: '#d5d7e3',
        blue: '#0084F9',
        bluegray: '##7E84A3',
        grayInput: '#707070',
        reddanger: '#FF0020'
    }
}
